module.exports = __webpack_public_path__ + "assets/images/add-to-plan.8718a28d45274f2188af1c4ff460d644.svg";